import React, { useState, useEffect } from 'react';

const ChristmasSanta = ({ position = 'bottom-right' }) => {
  const [isWaving, setIsWaving] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    // Wave animation every 5 seconds
    const waveInterval = setInterval(() => {
      setIsWaving(true);
      setTimeout(() => setIsWaving(false), 2000);
    }, 5000);

    return () => clearInterval(waveInterval);
  }, []);

  if (isClosed) return null;

  const positionStyles = {
    'bottom-right': { bottom: '120px', right: '20px' }, // Moved up to avoid blocking chat button
    'bottom-left': { bottom: '120px', left: '20px' },
    'top-right': { top: '100px', right: '20px' },
  };

  return (
    <div
      style={{
        position: 'fixed',
        ...positionStyles[position],
        zIndex: 40, // Below chat button (z-50) but above content
        cursor: 'pointer',
        transition: 'transform 0.3s ease',
      }}
      className={`christmas-santa ${isWaving ? 'waving' : ''}`}
    >
      {/* Close button */}
      <button
        onClick={() => setIsClosed(true)}
        style={{
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          background: 'rgba(0, 0, 0, 0.6)',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10,
        }}
        title="Hide Santa"
      >
        ×
      </button>

      {/* Santa Container */}
      <div
        style={{
          background: 'linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)',
          borderRadius: '20px',
          padding: '15px',
          boxShadow: '0 8px 32px rgba(220, 38, 38, 0.3)',
          border: '3px solid #dc2626',
          position: 'relative',
          maxWidth: '180px',
        }}
      >
        {/* Santa Emoji/Character */}
        <div
          style={{
            fontSize: '80px',
            textAlign: 'center',
            lineHeight: 1,
            transform: isWaving ? 'rotate(-10deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
            marginBottom: '10px',
          }}
        >
          🎅
        </div>

        {/* Greeting Text */}
        <div
          style={{
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: '600',
            color: '#dc2626',
            marginBottom: '8px',
          }}
        >
          Ho Ho Ho! 🎄
        </div>

        <div
          style={{
            textAlign: 'center',
            fontSize: '11px',
            color: '#065f46',
            fontWeight: '500',
          }}
        >
          Happy Holidays from CashifyGCMart!
        </div>

        {/* Decorative elements */}
        <div
          style={{
            position: 'absolute',
            top: '5px',
            left: '5px',
            fontSize: '20px',
          }}
        >
          ⭐
        </div>
        <div
          style={{
            position: 'absolute',
            top: '5px',
            right: '5px',
            fontSize: '20px',
          }}
        >
          ⭐
        </div>
      </div>

      <style>{`
        @keyframes wave {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-15deg); }
          75% { transform: rotate(15deg); }
        }
        
        .christmas-santa.waving {
          animation: wave 0.5s ease-in-out 3;
        }

        @media (max-width: 768px) {
          .christmas-santa > div {
            max-width: 140px !important;
            padding: 10px !important;
          }
          
          .christmas-santa > div > div:first-child {
            font-size: 60px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default ChristmasSanta;
